import React from 'react';
import { LegalPage } from './LegalPage';

export const RefundPage = () => <LegalPage page="refund" />;
